import { z } from "zod";

// The one side axis of the athlete model (PG-14 + PE-43, 2026-09-24,
// `next/measurement-contract.md §PG-14`).
//
// Pain and per-side prescription ask the model the same question (WHICH
// side), and Antenore took the model decision once for both: «every
// exercise is a red flag» if a one-sided pain can only be stored as
// bilateral, and a coach can't prescribe «per lato» for the same reason.
// So the axis lives here, outside `bodymap.ts`: prescription laterality
// has nothing to do with muscle slugs.
//
// Two shapes, one axis:
//   - `Side` is an IDENTITY with "both": what a logged set or a
//     prescribed slot was done on.
//   - `PerSide<T>` holds a value PER body side: a pain severity today,
//     a per-side capacity for the permanent-asymmetry case tomorrow.
//
// ⛔ Not `loadedSides: 1 | 2` (setVolume.ts): that is a COUNT for volume
// math (bilateral vs unilateral load), not which side.
export const Side = z.enum(["left", "right", "both"]);
export type Side = z.infer<typeof Side>;

export const BODY_SIDES = ["left", "right"] as const;
export type BodySide = (typeof BODY_SIDES)[number];

export type PerSide<T> = Partial<Record<BodySide, T>>;
